module.exports = __webpack_public_path__ + "static/media/green-tick.e803f649.svg";